import FormElement from './Form/FormElement';

export const FaramInputElement = FormElement('input');
export const FaramOutputElement = FormElement('output');
export const FaramErrorMessageElement = FormElement('errorMessage');
export const FaramErrorIndicatorElement = FormElement('errorIndicator');
export const FaramActionElement = FormElement('action');
export const FaramListElement = FormElement('list');
export const FaramSortableListElement = FormElement('sortableList');



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/vendor/react-store/components/General/FaramElements.js